// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const VideoExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 37 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={0.333008} width={36} height={36} rx={8} fill="#B16FCB" />
				<g opacity={0.8}>
					<path
						d="M12.4268 11C10.8562 11 9.58301 12.2732 9.58301 13.8437V22.1562C9.58301 23.7268 10.8562 25 12.4268 25H24.2393C25.8098 25 27.083 23.7268 27.083 22.1562V13.8437C27.083 12.2732 25.8098 11 24.2393 11H12.4268ZM15.708 15.5944C15.708 14.9288 16.4215 14.5069 17.0047 14.8277L21.3793 17.2337C21.9838 17.5661 21.9838 18.4346 21.3793 18.767L17.0047 21.173C16.4215 21.4938 15.708 21.0719 15.708 20.4063V15.5944Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
VideoExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default VideoExtension;
